import { Box, Grid, Typography } from '@mui/material';

export const PanelSection = ({
  title,
  children,
  isFieldGroup,
  helperText,
  sectionErrorMessage,
}: {
  title?: string;
  children?: React.ReactNode;
  isFieldGroup?: boolean;
  isEditable?: boolean;
  helperText?: string;
  sectionErrorMessage?: string;
}) => {
  const marginLeft = isFieldGroup ? '0px' : '16px';
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '&:not(:first-of-type)': { marginTop: '8px' },
      }}
    >
      <Typography
        variant={isFieldGroup ? 'body2' : 'h6'}
        sx={(theme) => ({
          margin: `8px 16px 0 ${marginLeft}`,
          color: theme.palette.text.secondary,
        })}
      >
        {title ?? undefined}
      </Typography>
      {helperText && (
        <Grid sx={{ marginLeft }}>
          <Typography display='block' variant='caption'>
            {helperText}
          </Typography>
        </Grid>
      )}
      {sectionErrorMessage && (
        <Grid sx={{ marginBottom: 1, marginLeft }}>
          <Typography display='block' variant='caption' sx={(theme) => ({ color: theme.palette.error.main })}>
            {sectionErrorMessage}
          </Typography>
        </Grid>
      )}
      {children}
    </Box>
  );
};
